var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('form-field-editor',{ref:"noteField",attrs:{"placeholder":"write your note here...","type":"note"},model:{value:(_vm.form.body),callback:function ($$v) {_vm.$set(_vm.form, "body", $$v)},expression:"form.body"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }